import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import DatePicker from "react-datepicker";
import CustomDatePickerInput from "../../_common/CustomDatePickerInput";
import { useDispatch, useSelector } from "react-redux";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import cmtCategoryActions from "../../../_actions/_qmsActions/cmtCategoryActions";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import cmtStageActions from "../../../_actions/_qmsActions/cmtStageActions";
import { getLocalISOString } from "../../../_utils/generalUtils";

export default function CmtModal_EditIssueStageAttachments(props) {
  const { modalState, toggleModal, issueStageId, divisionId, tabId } = props;

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"lg"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="paperclip" className="fa-fw mr-2" />
        Stage Attachments
      </ModalHeader>
      <ModalBody></ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
}
